
















































































    import axios, { AxiosResponse } from 'axios';
    import { Component, Vue } from 'vue-property-decorator';
    import SearchFilter from './Utilities/SearchFilter.vue';
    import { General } from '@/services/General';
    import CommunicationDetail from '@/components/CommunicationDetail.vue';
    import { ClaimEnum } from '@/services/ClaimEnum';
    import CommunicationCategory from '@/services/CommunicationCategory';
    import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";

    interface InputField {
        name: string
        type: string
        value: string | number
    }

    interface ContractType {
        key: number
        value: string
    }

    interface CommunicationTypeResult {
        id: string
        name: string
        mustHaveText: boolean
        canHaveText:boolean
        mustHaveTitle: boolean
        canHaveTitle: boolean
        canHaveAttachments: boolean
        canHaveLink: boolean
        mustHaveLink: boolean
        isActiveReadingConfirmation: boolean
    }

    interface ReadingConfirmationResult {
        id: string
        isMandatory: boolean
        isActive: boolean
        rowVersion: any
    }

    interface CommunicationSearchResult {
        id: string
        numericId: number
        text: string
        title: string
        //author: string
        creationDate: Date
        startDisplayDate: Date
        endDisplayDate: Date
        rowVersion: any
        //linkName: string
        linkUrl: string
        communicationType: CommunicationTypeResult
        readingConfirmation: ReadingConfirmationResult
    }

    interface CommunicationFilterModel {
        NumericId: number
        //CommunicationType: string
        Text: string
        Title: string
        IdCategory: string
        //Author: string
        StartCreationDate: string
        ContractType: string
        EndCreationDate: string
        IncludeDeletedCommunications: boolean
        Countries: string[]
        CommunicationsToRetrieve: number
        CurrentPage: number
        FreeText:string
    }

    interface CommunicationTableField {
        key: string
        label: string
        sortable: boolean
    }

    interface CommunicationResultPage {
        listPage: Array<CommunicationSearchResult>
        total: number
    }

    interface CountryTypeResult {
        idCountry: string
        code: string
        code3: string
        name: string
        numeric: string
        countryType: any
        codeType: string
        fullVisibility: boolean
        countryFather: CountryFather
        languages: any
}

    interface CountryFather {
        idCountry: string
        code: string
        code3: any
        name: string
        numeric: any
        countryType: any
        codeType: string
        fullVisibility: boolean
        countryFather: any
        languages: any
}

    interface FilterOption {
        value: string
        text: string
    }

    @Component({
        components: {
            SearchFilter, 
            CommunicationDetail,
            LeftClickOptionMenu
        }
    })
    export default class CommunicationsSearch extends Vue {
        communicationId: string = null;
        isCollapseVisible: boolean = false;
        activeFilterFromWidget: boolean = false;
        
        tableFields: Array<CommunicationTableField> = [
            {
                key: "searchIcon",
                label: "",
                sortable: false
            },
            {
                key: "numericId",
                label: "ID",
                sortable: false
            },
            {
                key: "title",
                label: "Title",
                sortable: false
            },
            // {
            //     key: "author",
            //     label: "Author",
            //     sortable: false
            // },
            {
                key: "category.name",
                label: "NameCategory",
                sortable: false
            },
            {
                key: "creationDate",
                label: "Date (mm/dd/yyyy)",
                sortable: false
            }
        ]

        //pacchetto per menu tasto destro su dettaglio entita'
        leftClickOptionMenuUrl: string = "/communications/";
        leftClickOptionMenuUrlArgument: string = "numericId";
        handleClick (event, item) {
            (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
        }

        freeText : string;
        // constant values
        CLICKABLE_SEARCH_ICON = "fa fa-search clickable"
        MODAL_ID = "communication-modal"
        // search filters
        numericIdFilter: number = null
        titleFilter: string = ""
        textFilter: string = ""
        communicationCategoryFilter: string = ""
        communicationCountryFilter: string = ""
        communicationContractTypeFilter: string = "";
        //communicationTypeFilter: string = ""
        //authorFilter: string = ""
        startCreationDateFilter: string = ""
        endCreationDateFilter: string = ""
        // attributes for managing communications searching
        currentCommunicationPage: number = 1
        filteredCommunications: Array<CommunicationSearchResult> = []
        loadingCommunications: boolean = false
        totalCommunicationRows: number = 0
        defaultFilter: FilterOption = {
            value: "",
            text: "Select an option"
        } 
        communicationCountriesOptions: Array<FilterOption> = [this.defaultFilter];
        //ommunicationTypeOptions: Array<FilterOption> = [this.defaultFilter]
        communicationCategoriesOptions: Array<FilterOption> = [this.defaultFilter]
        //communicationTypesAvailable: Array<CommunicationTypeResult> = []
        communicationCategoriesAvailable: Array<CommunicationCategory> = []
        communicationContractTypeOptions: Array<FilterOption> = []
        async searchFirstPageCommunications(freeText: string): Promise<void> {
            if (freeText != null) 
                this.freeText = freeText;
           //this.inputFields.forEach((inputField: InputField): void => this.mapInputField(inputField))
            this.currentCommunicationPage = 1
            this.filteredCommunications = []
            await this.searchCommunications(freeText)
        }

       created() {
            //imposto da qui il prop da inviare al componente "SearchFilter", perche' al mounted il componente e' gia' renderizzato
            if (this.$route.path.search("/category=")>-1){
                this.activeFilterFromWidget = true;
            } 
       }


       async mounted(){ 
            await this.getCommunicationCategories();
            if (this.userCanManageCommunication) {
                await this.getCountriesForUser();
            }
            await this.getCountriesForUser();
            await this.getContractTypes();
            if (this.$route.path.search("/category=")>-1){
                this.isCollapseVisible = true;
                let idCategory = this.$route.params.id.replace('category=','');                
                let category =  this.communicationCategoriesOptions.find(x => x.value == idCategory);
                this.communicationCategoryFilter = category.value;  
                this.searchFirstPageCommunications("");   
                return;
            }
            
            if(this.$route.params.id) {
                let communicationsResult = new Array<CommunicationSearchResult>();
                this.numericIdFilter = Number(this.$route.params.id);
                communicationsResult = await this.getFilteredCommunications(1,"");
                this.viewCommunicationDetail(communicationsResult[0],false)                      
            }

            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                console.log(modalId)
                if (modalId=='communication-modal'){
                    this.$router.push({name:'Communications'});  
                    this.numericIdFilter = null;
                }
                
            })                          
        }

        async searchNextPageCommunications(freeText:string): Promise<void> {
            this.currentCommunicationPage = this.currentCommunicationPage + 1
            await this.searchCommunications(freeText)
        }

        async searchCommunications(freeText:string): Promise<void> {
            this.loadingCommunications = true
            console.log("end = "+this.endCreationDateFilter)
            if (this.endCreationDateFilter != "")
                this.endCreationDateFilter = this.endCreationDateFilter + "T23:59:59"
            else
                this.endCreationDateFilter = ""
            this.filteredCommunications = this.filteredCommunications.concat(await this.getFilteredCommunications(this.currentCommunicationPage,freeText))
            this.loadingCommunications = false
        }


        async getFilteredCommunications(currentPage: number,freeText:string): Promise<Array<CommunicationSearchResult>> {
            
           try {
                let communicationFilterModel: CommunicationFilterModel = {                    
                    NumericId: this.numericIdFilter,
                    IdCategory: this.communicationCategoryFilter,
                    Text: this.textFilter,
                    Title: this.titleFilter,
                    //Author: this.authorFilter,
                    StartCreationDate: this.startCreationDateFilter,
                    ContractType: this.communicationContractTypeFilter,
                    EndCreationDate: this.endCreationDateFilter,
                    IncludeDeletedCommunications: false,
                    Countries: [this.communicationCountryFilter],
                    CommunicationsToRetrieve: 10,
                    CurrentPage: currentPage,
                    FreeText: freeText
                }
                console.log(communicationFilterModel)
                let communicationsResult: AxiosResponse<any> = await axios.post<CommunicationResultPage>(
                    General.GetApiUrl('/api/Communication/Filter'),
                    communicationFilterModel,
                    {
                        withCredentials: true,
                        responseType: 'json'
                    }
                )

                //console.log(communicationsResult)

                this.totalCommunicationRows = communicationsResult.data.total
                //return this.standardizeCommunications(communicationsResult.data.listPage)
                return communicationsResult.data.listPage;
            } catch (e) {
                console.log(e)
                return [] 
            }
        }

        // standardizeCommunications(communications: Array<CommunicationSearchResult>): Array<CommunicationSearchResult> {
        //     communications.forEach((communication: CommunicationSearchResult): void => {
        //         if (communication.title == null && communication.linkName != null)
        //             communication.title = communication.linkName
        //     })
        //     return communications
        // }

        async viewCommunicationDetail(communication,setRouterId:boolean = true): Promise<void> {            
            this.communicationId = communication.id;
            if(setRouterId)
            this.$router.push("/communications/" + communication.numericId);
            this.$bvModal.show(this.MODAL_ID);
            
        }

        async communicationCreationModal(): Promise<void> {
            if(this.$route.params.id)
                this.$router.push("/communications");

            this.communicationId = null
            this.$bvModal.show(this.MODAL_ID)
        }
        get userCanManageCommunication() {
            return General.CheckAuthorization(ClaimEnum.CanManageCommunications) || General.CheckAuthorization(ClaimEnum.CanManageCommunicationsForCountry);
        }
        resetSearchFilters(): void {
            this.numericIdFilter= null
            this.titleFilter= ""
            this.textFilter = ""
            this.communicationCategoryFilter= ""
            this.startCreationDateFilter = ""
            this.endCreationDateFilter = ""
            this.communicationCountryFilter = ""
        }

        async getCountriesForUser(): Promise<void>{ 
            try{
                if(this.userCanManageCommunication){
                    this.userCanManageCommunication;
                let communicationCountries = (await axios.get<Array<CountryTypeResult>>(
                    General.GetApiUrl(`/api/Communication/GetCountriesForUser`),
                    {
                        withCredentials: true,
                        responseType: 'json'
                    })).data
                    this.communicationCountriesOptions = [this.defaultFilter].concat(communicationCountries.map(
                        (communicationCountry: CountryTypeResult): FilterOption => {
                            return {
                                text: communicationCountry.name,
                                value: communicationCountry.code
                            }
                        }))
                }
            }catch(e){
                console.log(e)
                General.showAlertDanger("There was an error while loading communication Countries!", this)
            }  
        }

        async getContractTypes(){
            
            try {
                let contracts = (await axios.get<Array<ContractType>>(
                    General.GetApiUrl("/api/Communication/GetAllContractTypes"),
                    {
                        withCredentials: true,
                        responseType: "json"
                    }
                )).data;
                this.communicationContractTypeOptions = [this.defaultFilter].concat(contracts.map(
                    (contract: ContractType): FilterOption => {
                        return{
                            text: contract.value,
                            value: contract.key.toString()
                        }
                    }
                ));
            } catch (e) {
                console.log(e)
                General.showAlertDanger("There was an error while loading communication contracts!", this)
            }
        }

        async getCommunicationCategories(): Promise<void> {
            try {
                if (this.communicationCategoriesAvailable.length === 0) {
                    let response = await axios({
                        method: 'post',
                        url: General.GetApiUrl('/api/Communication/GetCommunicationCategoriesWithFilter'),
                        responseType: 'json',
                        withCredentials: true,
                        data: {
                            IdCategory : null,
                            TypeId : null,
                            Name : null
                        }
                    });

                    let communicationCategories = response.data;

                    this.communicationCategoriesAvailable = communicationCategories
                    this.communicationCategoriesOptions = [this.defaultFilter].concat(communicationCategories.map(
                        (communicationCategory: CommunicationCategory): FilterOption => {
                            return {
                                text: communicationCategory.name,
                                value: communicationCategory.idCategory
                            }
                        }
                    ))
                }
            } catch(e) {
                console.log(e)
                General.showAlertDanger("There was an error while loading communication Category!", this)
            }
        }

        insertDefaultOption() {
            if (this.communicationCategoriesOptions.length === this.communicationCategoriesAvailable.length) {
                this.communicationCategoriesOptions = [this.defaultFilter].concat(this.communicationCategoriesOptions)
                //this.findInputField("Category").value = ""
            }
        }
    }

